import { render } from "./Spinner.vue?vue&type=template&id=cd84183a"
const script = {}
script.render = render

export default script